import { Component, ElementRef, EventEmitter, HostListener, Input, Output, ViewChild } from '@angular/core';

export interface ExportFormat {
  ExportCsv: boolean;
  ExportXlsx: boolean;
}



@Component({
  selector: 'app-excel-csv-select',
  templateUrl: './excel-csv-select.component.html',
  styleUrls: ['./excel-csv-select.component.scss']
})
export class ExcelCsvSelectComponent {

  @Input() ExportText: string = "";
  @Input() loading: boolean = false;
  @Output() exportFormatEmitter = new EventEmitter<ExportFormat>();

  DropdownOpen: boolean = false;

  ExportFormat: ExportFormat = {
    ExportCsv: false,
    ExportXlsx: false
  }

  alignRight = true;
  constructor(private readonly elementRef: ElementRef) { }



  @ViewChild('trigger', { static: true }) trigger!: ElementRef;
  @ViewChild('dropdown') dropdown!: ElementRef;

  toggle() {
    this.calculatePosition();
  }

  calculatePosition() {
    const triggerRect = this.trigger.nativeElement.getBoundingClientRect();
    const viewportWidth = window.innerWidth;

    const spaceRight = viewportWidth - triggerRect.right;
    const spaceLeft = triggerRect.left;

    this.alignRight = spaceRight > spaceLeft;
  }

  openDropdown(event: Event) {
    if (event) {
      event.stopPropagation(); // evita que el HostListener lo detecte como clic fuera
    }
    this.DropdownOpen = !this.DropdownOpen
    if (this.DropdownOpen) {
      this.calculatePosition();

    }
  }

  exportSelected() {
    if (this.loading) { return }
    this.DropdownOpen = false;
    this.exportFormatEmitter.emit(this.ExportFormat)
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const clickedInside = this.elementRef.nativeElement.contains(event.target);
    if (!clickedInside) {
      this.DropdownOpen = false;
    }
  }
}
